module.exports = __FOREMAN_VENDOR__JQUERY__;